<app-fixed-editor *ngIf="_element.editorId && fixedEditor && !isSubmitted" [element]="fixedEditor"></app-fixed-editor>
<div *ngIf="!isSubmitted && !immediateFeedBackRequired" [attr.id]="'destination'+index"
  class="new-question new-question-top-align mx-auto" [class.fullheight-scroll-container]="!isSubmitted">
  <div class="new-question__container next-button-spacing">
    <div class="new-question--titleBox">
      <div [froalaView]="_element?.question" class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24"></div>
      <div *ngIf="_element?.description" class="new-question--hint">
        {{_element?.description}}
      </div>
    </div>
    <app-text-text-mfq [answer]="_answer" [options]="_element?.options"
      [allOptionsToDisplay]="_element.allOptionsToDisplay" (showNextButton)="nextButtonHandler($event)"
      *ngIf="_element.type =='TEXT'">
    </app-text-text-mfq>
    <app-text-image-mfq [answer]="_answer" [options]="_element?.options"
      [allOptionsToDisplay]="_element.allOptionsToDisplay" (showNextButton)="nextButtonHandler($event)"
      *ngIf="_element.type =='TEXTTOIMAGE'">
    </app-text-image-mfq>
    <app-exercise-navigation-bar [id]="id" [questionAttempted]="questionAttempted" (onNext)="next()"
      (onSubmit)="next(true)"
      [exerciseTimetrackingdata] ="exerciseTimetrackingdata"
      [index]='index' 
      >
    </app-exercise-navigation-bar>
  </div>
</div>
<div *ngIf="!isSubmitted && immediateFeedBackRequired" [attr.id]="'destination'+index"
  class="new-question new-question-top-align mx-auto" [class.fullheight-scroll-container]="!isSubmitted">
  <div class="new-question__container next-button-spacing">
    <div class="new-question--titleBox">
      <div [froalaView]="_element?.question" class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24"></div>
      <div *ngIf="_element?.description" class="new-question--hint">
        {{_element?.description}}
      </div>
    </div>
    <app-text-text-mfq [answer]="_answer" [options]="_element?.options" [questionChecked]="questionChecked"
      [immediateFeedBackRequired]="true" [allOptionsToDisplay]="_element.allOptionsToDisplay"
      (showNextButton)="nextButtonHandler($event)" *ngIf="_element.type =='TEXT'">
    </app-text-text-mfq>
    <app-text-image-mfq [answer]="_answer" [options]="_element?.options" [questionChecked]="questionChecked"
      [immediateFeedBackRequired]="true" [allOptionsToDisplay]="_element.allOptionsToDisplay"
      (showNextButton)="nextButtonHandler($event)" *ngIf="_element.type =='TEXTTOIMAGE'">
    </app-text-image-mfq>
    <div *ngIf="questionAttempted && questionChecked &&  _element?.isFeedbackEnabled" class="overall-feedback pb-0">

      <p class=" montserrat-medium terneryColor font-14 font-mob-12 mg-b15 pd-xs-t30" *ngIf="variableFeedback">{{variableFeedback}}</p>
      <p [froalaView]="_element.feedback" class="overall-feedback__desc"></p>
    </div>
    <app-exercise-navigation-bar [id]="id" [immediateFeedBackRequired]="true" [questionAttempted]="questionAttempted"
      (onReview)="check()" (onNext)="next()" (onSubmit)="next(true)" [questionChecked]="questionChecked"
      [exerciseTimetrackingdata] ="exerciseTimetrackingdata"
      [index]='index'
      >
    </app-exercise-navigation-bar>
  </div>
</div>
<div *ngIf="isSubmitted" [attr.id]="'destination'+index" [class.new-options--not-answered]="!_answer"
  class="new-question new-question-top-align mx-auto">
  <div class="new-question__container">
    <div class="new-question--titleBox"
      [class.score-applied]="_element?.isScoring &&  _answer && points  && isResultPublished">
      <div [froalaView]="_element?.question" class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24"></div>
      <!-- <span *ngIf="!isPractice && _element?.isScoring &&  _answer && points  && isResultPublished && !isTouchstone"
        class="answer-point">Points:
        {{(points?points.point:0 ) | number:'1.0-2'}} out of
        {{(points?points.total:0 ) | number:'1.0-2'}}</span> -->
    </div>
    <app-text-text-mfq [answer]="_answer" [isSubmitted]="isSubmitted" [correctAnswers]="correctAnswers"
      [options]="_element?.options" *ngIf="_element.type =='TEXT'">
    </app-text-text-mfq>
    <app-text-image-mfq [answer]="_answer" [isSubmitted]="isSubmitted" [correctAnswers]="correctAnswers"
      [options]="_element?.options" *ngIf="_element.type =='TEXTTOIMAGE'">
    </app-text-image-mfq>
     <!-- thrive -->
     <ng-container *ngIf="questionBlos && questionBlos.length">     
      <h5 class="question__thrive">Thrive Skills:</h5>
      <div class="question__thrive-list">
        <ul>
          <ng-container *ngFor="let blo of questionBlos">
            <li [innerHTML]="blo.shortStatement"></li>
          </ng-container>
        </ul>
      </div>
    </ng-container>
    <div *ngIf="_element?.isFeedbackEnabled" class="overall-feedback">
      <div class="new-question__container">
        <p class=" montserrat-medium terneryColor font-14 font-mob-12 mg-b15 pd-xs-t30" *ngIf="variableFeedback">{{variableFeedback}}</p>
        <p [froalaView]="_element.feedback" class="overall-feedback__desc"></p>
      </div>
    </div>
  </div>
  <!-- <app-like-dislike [id]="id" *ngIf="_element?.isFeedbackEnabled" [userFeedback]="userFeedback" [_element]="_element"
    (reportFeedback)="_reportFeedback($event)" (likeDislike)="_likeDislike($event)">
  </app-like-dislike> -->
</div>
